<div class="d-flex align-items-center">

<div class="maintenance_notice" *ngIf="maintenance?.maintenance_dashboard_mode">
    <div class="d-flex align-items-center maintenance_wrap">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.0002 22C17.5002 22 22.0002 17.5 22.0002 12C22.0002 6.5 17.5002 2 12.0002 2C6.50024 2 2.00024 6.5 2.00024 12C2.00024 17.5 6.50024 22 12.0002 22Z" fill="#D50000" stroke="#D50000" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 8V13" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.9941 16H12.0031" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span >Scheduled Maintenance Notice</span>
    </div>
    <div class="hover--content">
        <h6>{{maintenance.maintenance_dashboard_mode_text1}}</h6>
        <p class="mb-3" [innerHtml]="maintenance.maintenance_dashboard_mode_text2"></p>
        <p class="mb-0">{{maintenance.maintenance_dashboard_mode_text3}}</p>
    </div>
</div>

<div class="d-flex align-items-center pe-3">
    <div>
        <label class="m-0 me-3" tappable (click)="goToOldVersion()" *ngIf="userProfileData.show_old_version == 1">Switch to old
            version</label>
    </div>
    <div class="text-right me-3" *ngIf="currentLoc && userProfileData.role_id !== 4">
        <button mat-raised-button class="loc_btn" (click)="addLocation()">+ Add New Business</button>
    </div>

    <div class="d-inline-flex me-2 pointer" routerLink="/app/finance-customer" *ngIf="!(button_type == 2 || button_type == 3 || button_type == 4 || button_type == 5)">
        <img src="assets/img/gif/play.gif" style="height: 50px; width: 50px;">
        <span class="me-2 dash-start">Finance Now</span>
    </div>
    <div class="play-border" *ngIf="!(button_type == 2 || button_type == 3 || button_type == 4 || button_type == 5)"></div>
    <div class="d-flex align-items-center ms-3" [ngClass]="{'me-4': (path == '/app/dashboard')}">
      <!-- *ngIf="userProfileData.role_id == 4 || userProfileData.role_id == 1" -->
        <div style="position: relative;" >
            <img src="assets/img/svg/notification.svg" tappable (click)="openNotifications()">
            <ng-container *ngIf="_main.unread_count > 0">
                <div class="unread_label">{{_main.unread_count>=100 ? '99+': _main.unread_count }}</div>
            </ng-container>
        </div>
        <div class="ms-5 d-flex align-items-center"
            *ngIf="!(button_type == 1 || button_type == 2 || button_type == 3 || button_type == 4)"></div>
        <div *ngIf="button_type == 2 || button_type == 3 || button_type == 4 || button_type == 6"
            class="header-finance-btn ms-5 d-flex align-items-center">
            <button (click)="show_popup()">
                {{ button_type == 3 ? 'No Fee Payment Processing' : button_type == 4 ? 'Accounts Receivable' :button_type == 6 ? 'Subscription' :'Finance a Customer'}}
            </button>

            <button class="d-flex" (click)="show_popup()">
                <mat-icon class="image_class" [ngClass]="{'image_active': popup == true}">
                    keyboard_arrow_down</mat-icon>
                <div style="position: absolute;" class="py-2 custom_popup" *ngIf="popup == true">
                    <div class="px-3 optionDrop text-start py-2" (click)="clearLocalStorage(2)" style="word-break: break-all;"
                        *ngIf="userProfileData.can_finance == 1 || userProfileData.role_id == 1 || (profileData && profileData.can_finance == 1)">
                        Finance a Customer
                    </div>
                    <div class="px-3 optionDrop text-start py-2" (click)="clearLocalStorage(3)" style="word-break: break-all;"
                        *ngIf="userProfileData.show_process_payment == 1 || userProfileData.role_id == 1 || (profileData && profileData.show_payment_process == 1)">
                        No Fee Payment Proceesing
                    </div>
                    <div class="px-3 optionDrop text-start py-2" (click)="clearLocalStorage(4)" style="word-break: break-all;"
                        *ngIf="userProfileData.show_ar == 1 || userProfileData.role_id == 1 || (profileData &&profileData.show_ar == 1)">
                        Accounts Receivable
                    </div>
                    <div class="px-3 optionDrop text-start py-2" style="word-break: break-all;"
                        *ngIf="showSubscription?.payment_process_subscription_settings?.show_pp_subscription === 1" (click)="goToSubscription()">
                        Subscription
                    </div>
                </div>
            </button>
        </div>
    </div>

</div>

</div>
